import { Box, Typography } from "@mui/material";
import { useStyles } from "./EmptyState.styles";

interface Props {
  icon: JSX.Element;
  title: string;
  description?: string;
  button?: JSX.Element;
  className?: string;
}

export const EmptyState = ({
  icon,
  title,
  description,
  button,
  className,
}: Props) => {
  const classes = useStyles();

  return (
    <Box className={`${classes.basicWrapper} ${className}`}>
      <Box className={classes.iconWrapper}>{icon}</Box>
      <Typography mt={12} mb={4} className={classes.title}>
        {title}
      </Typography>
      {description && (
        <Typography mb={12} className={classes.description}>
          {description}
        </Typography>
      )}
      {button && button}
    </Box>
  );
};
